import React from 'react';
import './VerificationPending.css';

const VerificationPending = ({ user, handleLogout }) => {
  return (
    <div className="verification-pending">
      <h2>{user.organization?.isActive === false ? 'Account Deactivated' : 'Verification Pending'}</h2>
      <p>
        {user.organization?.isActive === false
          ? `Your organization, ${user.organization?.companyName || 'Unknown'}, has been deactivated. Please contact support at support@scover.co.za for further details or to request reactivation.`
          : `Your organization, ${user.organization?.companyName || 'Unknown'}, needs to be verified by the Scover team. You’ll receive an email at ${user.organization?.emailNotifications || user.email} once verification is completed.`}
      </p>
      <button onClick={handleLogout} className="logout-button">Log Out</button>
    </div>
  );
};

export default VerificationPending;